<section id="aboutUs" class=" d-flex align-items-center offering z-depth-5 section" #offering>
    <div class="container " data-aos="fade-up">

        <div class="section-title">
            <h2 class="fw-bold">{{aboutUsHeader}}</h2>
        </div>
        

        <div class="row justify-content-center mb-2" data-aos="zoom-in" data-aos-delay="150">
            <div class="col-xl-12  justify-content-center">

                <div class="text-center ">

                    <p class="card-text text-justify text-break descText">
                        <span style="font-weight:700">ASD</span> is an Accenture
                        proprietary capability that offers technical diagnostic assessment solutions for various SAP
                        systems. ASD offers insightful diagnostic reports that can provide deep technical insights
                        into your SAP systems. It may enable you in answering all sorts of critical technical
                        questions related to the SAP system.
                    </p>

                    <p class="card-text text-justify text-break descText">
                        ASD offers insights on SAP standard business process configuration & actual usage, custom
                        object volume-distribution and usage, functional customization classification and effective
                        usage, current organization structure and configurations, effectiveness of present security
                        framework, code quality assessment, change analysis, etc. More over, ASD generates pseudo
                        code-flows for custom program objects to provide a high level overview of microscopic details of
                        the code. From the security point of view, ASD offers a deep-dive into the user-role
                        relationships, role-transaction assignment volumes, user/role quality checks, top-50 Tcode
                        usage and technical details related to them.

                    </p>
                    <p class="card-text text-justify text-break descText">
                        All of this information can be proven useful in taking critical business decisions in
                        various use-case scenarios:

                    </p>

                </div>
                <div class="row  ml-5" data-aos="zoom-in fade top" data-aos-delay="150">
                    <div class="col"></div>
                    <div class="col ">

                        <figure>

                            <a (mouseenter)="mouseEnter('decision')" (mouseleave)="mouseLeave('decision')"
                                class="abtTag">
                                <img class="img-responsive aboutUsImage rounded-circle z-depth-5"
                                    src="../../../assets/Images/aboutus/1_Decision.jpg">
                            </a>
                            <figcaption>
                                <h6 class="card-text text-break descText textfadecolor ml-2"> {{decisionHeader}}</h6>
                            </figcaption>
                       
                        </figure>
                    </div>

                    <div class="col">
                        <figure>
                            <a (mouseenter)="mouseEnter('CI')" (mouseleave)="mouseLeave('CI')">
                                <img class="img-responsive aboutUsImage rounded-circle  z-depth-5"
                                    src="../../../assets/Images/aboutus/2_Continuous_Improvement.jpg" />
                            </a>
                            <figcaption>
                                <h6 class="card-text text-break descText textfadecolor ml-2">
                                    {{continuousImprovementHeader}}</h6>
                            </figcaption>
                        </figure>
                    </div>

                    <div class="col">
                        <figure>
                            <a (mouseenter)="mouseEnter('diligence')" (mouseleave)="mouseLeave('diligence')">
                                <img class="img-responsive aboutUsImage rounded-circle  z-depth-5"
                                    src="../../../assets/Images/aboutus/3_SystemConfiguration.jpg" />
                            </a>
                            <figcaption>
                                <h6 class="card-text text-break descText textfadecolor ml-2"> {{diligenceHeader}}</h6>
                            </figcaption>
                        </figure>
                    </div>
                    <div class="col">
                        <figure>
                            <a (mouseenter)="mouseEnter('KT')" (mouseleave)="mouseLeave('KT')">
                                <img class="img-responsive aboutUsImage rounded-circle  z-depth-5"
                                    src="../../../assets/Images/aboutus/4_KnowledgeTransition.jpg" />
                            </a>
                            <figcaption>
                                <h6 class="card-text text-break descText textfadecolor">{{ktHeader}}</h6>
                            </figcaption>
                        </figure>
                    </div>
                    <div class="col">
                        <figure>
                            <a (mouseenter)="mouseEnter('merger')" (mouseleave)="mouseLeave('merger')">
                                <img class="img-responsive aboutUsImage rounded-circle  z-depth-5"
                                    src="../../../assets/Images/aboutus/5_Merger.jpg" />
                            </a>
                            <figcaption>
                                <h6 class="card-text text-break descText textfadecolor ml-3"> {{rollOut}}</h6>
                            </figcaption>
                        </figure>

                    </div>
                    <div class="col"></div>
                </div>

                <div class="card  rounded-top 
                         border border-secondary mb-1 waves-effect z-depth-2 abtDiv" [hidden]="!showDiv">

                    <div class="card-body ">

                        <p class="card-text text-break descText" style="width: 140vh;margin-left: 100vh;" >
                            {{html}}
                        </p>

                    </div>
                </div>           

            </div>

        </div>
        <div class="row justify-content-center " style="margin-top:-1vh!important
        ">
          
            <p class="mod-singular-pager text-center">
                <a  href="#headeContent"  class="mod-singular-prev js-singular-prev scrollto z-depth-5 scrollarrow" 
                 mdbTooltip="Home" placement="left"></a>
                <a  href="#offering" class="mod-singular-next js-singular-next scrollto z-depth-5 scrollarrow" 
                 mdbTooltip="Our Offerings" placement="right"></a>   
            </p>
        </div>
    </div>
</section>